<template>
  <div>
    <el-button
      type="primary"
      round
      @click="back"
      size="mini"
      style="margin: 10px 0; margin-left: 10%"
      >返回</el-button
    >
    <div class="wrapCon">
      <div class="left">
        <h3 style="font-size: 18px !important">电话咨询</h3>
        <div class="linkCon">
          <div :class="index == 1 ? 'active' : 'link'" @click="clickLink(1)">
            纳税服务热线
          </div>
          <div :class="index == 2 ? 'active' : 'link'" @click="clickLink(2)">
            主管税务机关电话
          </div>
          <div :class="index == 3 ? 'active' : 'link'" @click="clickLink(3)">
            其他县区税务机关电话
          </div>
        </div>
      </div>
      <div class="right">
        <div v-show="index == 1">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">纳税服务热线</span>
            </div>
            <div class="content">纳税服务热线：12366</div>
          </div>
          <div class="middle">
            <div class="fontStyle">主要服务功能：</div>
            <p style="margin: 10px auto">
              负责通过热线、手机APP等渠道受理纳税人、缴费人、扣缴义务人和其他涉税当事人来电，为纳税人提供纳税缴费咨询、涉税违法举报受理等服务。
            </p>
          </div>
        </div>
        <div v-show="index == 2">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">主管税务机关电话</span>
            </div>
          </div>
          <div class="middle" style="margin-top: 10px">
            <p style="margin: 10px auto">
              您的主管税务机关是：国家税务总局信阳市第一税务分局，咨询热线电话是：0395-2935609
            </p>
          </div>
        </div>
        <div v-show="index == 3">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">其他县区税务机关电话</span>
            </div>
          </div>
          <div class="middle" style="margin-top: 10px">
            <p>各县（区）办税服务厅电话</p>
            <el-table
              :data="tableData"
              border
              style="width: 100%; margin-top: 20px"
              :header-row-style="headerStyle"
            >
              <el-table-column
                prop="num"
                label="序号"
                width="80"
                type="index"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="name" label="办税厅名称">
              </el-table-column>
              <el-table-column prop="phone" label="办税厅电话" align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      index: 1,
      headerStyle: {
        color: "#000",
        background: "#ccc",
      },
      tableData: [
        {
          name: "国家税务总局信阳市税务局第一税务分局办税服务厅",
          phone: "0395-2935609",
        },
        {
          name: "国家税务总局信阳市源汇区税务局办税服务厅",
          phone: "0395-2122591",
        },
        {
          name: "国家税务总局信阳市郾城区税务局办税服务厅",
          phone: "0395-5351561",
        },
        {
          name: "国家税务总局信阳市召陵区税务局办税服务厅",
          phone: "0395-2160832",
        },
        {
          name: "国家税务总局舞阳县税务局办税服务厅",
          phone: "0395-7190086",
        },
        {
          name: "国家税务总局临颍县税务局办税服务厅",
          phone: "0395-8819223",
        },
        {
          name: "国家税务总局信阳市税务局第二税务分局办税服务厅",
          phone: "0395-5691126",
        },
        {
          name: "国家税务总局信阳经济技术开发区税务局办税服务厅",
          phone: "0395-2665526",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    back() {
      this.$parent.topNav = true;
      this.$parent.showFlag = "";
      // this.$router.push({ name: "policyService" });
    },
    clickLink(param) {
      this.index = param;
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.fontStyle {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.back {
  cursor: pointer;
  margin: 0 auto;
}
.wrapCon {
  width: $width;
  min-height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .left {
    width: 20%;
    background: #f7f7f7;
    padding: 20px 0;
    // border: 1px solid #ccc;
    h3 {
      text-align: center;
      color: #fff;
      font-size: 22px;
      margin-bottom: 5px;
      margin: 0px auto;
      background-color: #0241FF;
      line-height: 64px;
    }
    .linkCon {
      div {
        cursor: pointer;
        font-size: 18px;
        width: 88%;
        margin: 10px auto;
        text-align: center;
        border: 1px solid #ddd;
        line-height: 52px;
        border-radius: 5px;
        background-color: #fff;
        &:hover {
          color: #fff;
          background-color: #1472FF;
        }
      }
      .active {
        color: #fff;
        background-color: #1472FF;
      }
    }
  }
  .right {
    width: 78%;
    min-height: 400px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    .right_top {
      width: 100%;
      .title {
        height: 64px;
        border-bottom: 1px solid #ccc;
        span {
          display: inline-block;
          min-width: 110px;
          height: 100%;
          text-align: center;
          line-height: 64px;
          border-bottom: 3px solid #1472FF;
        }
      }
      .content {
        background-color: #ebf6fc;
        padding: 20px;
        margin-top: 10px;
        margin-bottom: 40px;
      }
    }
    .middle {
      background-color: #ebf6fc;
      padding: 20px;
    }
  }
}
</style>
